// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) navigate(from, { replace: true });
    else setError(r.error);
  };

  const googleSignIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] grid grid-cols-1 md:grid-cols-2" data-testid="login-page">
      <div className="hidden md:block relative border-r border-border">
        <img src="https://images.unsplash.com/photo-1709525616662-8d9f9a995ceb" alt="Golf course" className="absolute inset-0 w-full h-full object-cover image-mono" />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/20 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10">
          <div className="overline">TGI Golfer Fund</div>
          <div className="font-display text-4xl mt-3">Welcome back to <span className="text-primary">the green room.</span></div>
        </div>
      </div>

      <div className="flex items-center justify-center py-20 px-6">
        <div className="w-full max-w-md">
          <div className="overline">Sign in</div>
          <h1 className="font-display text-4xl md:text-5xl mt-3">Continue your story.</h1>

          <button onClick={googleSignIn} className="mt-8 w-full h-12 border border-foreground flex items-center justify-center gap-3 hover:bg-foreground hover:text-background transition-colors" data-testid="google-signin-btn">
            <span className="text-sm tracking-wide">Continue with Google</span>
          </button>

          <div className="my-8 flex items-center gap-3 text-xs text-foreground/50">
            <div className="flex-1 h-px bg-border" />
            <span>or with email</span>
            <div className="flex-1 h-px bg-border" />
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full h-12 px-4 border border-border bg-background outline-none focus:border-primary" data-testid="login-email" />
            <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full h-12 px-4 border border-border bg-background outline-none focus:border-primary" data-testid="login-password" />
            {error && <div className="text-sm text-destructive" data-testid="login-error">{error}</div>}
            <button disabled={loading} className="btn-primary w-full" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-6 text-sm text-foreground/60">
            New here? <Link to="/register" className="text-primary hover:underline" data-testid="register-link">Create an account</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
